export default Backbone.View.extend({
  // A view that contains the search results
  // and map. When the user clicks the map resize button
  // we change the mapConfig model, which triggers a class on
  // the container that handles the layout change.

  el: '.js-search-map-size-view',

  events: {
    'click .js-search-map-resize-button': 'toggleMapSize',
  },

  initialize() {
    this.model.on('change:mapSize', _.bind(this.updateMapSize, this));
  },

  toggleMapSize() {
    if (this.model.get('mapSize') !== 'large') {
      this.model.set('mapSize', 'large');
    } else {
      this.model.set('mapSize', 'small');
    }
    Rover.pubSub.trigger('map:resize');

    $.cookie('mapSize', this.model.get('mapSize'), { expires: 365, path: '/' });

    // track the event
    dataLayer.push({
      event: 'search-map-size-changed',
      mapSize: this.model.get('mapSize'),
    });
  },

  updateMapSize() {
    this.$el.toggleClass('large-map-active', this.model.get('mapSize') === 'large');
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/map_size_view.js